import script from "./FileProcessingQa.vue?vue&type=script&setup=true&lang=js"
export * from "./FileProcessingQa.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__